
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api"
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { usePermissions } from "layouts/Admin";
import { invoicesSelector } from "slices/invoiceSlice";
import { fetchGeneratedInvoices } from "slices/invoiceSlice";
import { Link } from "react-router-dom";
import { cdn } from "constants/common";
import { userSelector } from "slices/userSlice";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { removeMultipleInvoices } from "slices/invoiceSlice";
import { changeStatus } from "slices/invoiceSlice";
import { consolidateInvoices } from "slices/invoiceSlice";
import ConfirmationStatus from "components/common/ConfirmationMessageStatus";
import { Controller, useForm } from "react-hook-form";
import { AsyncPaginate } from "react-select-async-paginate";
import ErrorMessage from "components/common/ErrorMessage";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { Select } from "@mui/material";
import moment from 'moment';
import { selectCustomStyles } from "components/common/Select";
import { fetchTypes } from "slices/typeSlice";
import Swal from "sweetalert2";
import { Modal, ModalBody, ModalFooter } from 'reactstrap';

const apiService = new Api();

function InvocieList() {
    const dispatch = useDispatch()
    const startDateRef = React.useRef(null);
    const endDateRef = React.useRef(null);
    const [clientState, setClientState] = useState([]);
    const [consolidateModal, setConsolidateModal] = useState(false);
    const { checkPermission } = usePermissions();
    const { user } = useSelector(userSelector);
    const userToken = user.token;
    const { generatedInvoices, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(invoicesSelector);

    const [addForm, setAddForm] = React.useState({
        show: false,
        item: {}
    });
    const refAddutton = React.useRef(null);

    const [selectedItems, setSelectedItems] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [selectAll, setSelectAll] = React.useState(false);
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [statusModal, setStatusModal] = React.useState(false);
    const [consolidateLoading, setConsolidateLoading] = useState(false);
    const [itemId, setItemId] = React.useState()
    const [currentPage, setCurrentPage] = React.useState(1);
    const [searchTerm, setSearchTerm] = React.useState("");
    const [sortConfig, setSortConfig] = React.useState({});

    // const isInvoiceSelectable = (invoice) => invoice?.status?.toLowerCase() !== 'paid';
    // const getSelectableInvoiceIds = () => generatedInvoices?.filter(isInvoiceSelectable).map((item) => item.id.toString()) || [];
    const isInvoiceSelectable = (invoice) => invoice?.status === 'Pending';
    // const selectableInvoices = generatedInvoices?.filter(isInvoiceSelectable) || [];
    const selectableInvoices = checkPermission('Download Invoices')
    ? (generatedInvoices || [])
    : (generatedInvoices?.filter(isInvoiceSelectable) || []);

    // React.useEffect(() => {
    //     dispatch(fetchGeneratedInvoices())
    // }, [])

    const defaultValues = {
        invoicing_period: "",
        start_date: "",
        end_date: "",
        client_ids: [],
    };

    const [filters, setFilters] = useState({
        invoicing_period: "",
        start_date: "",
        end_date: "",
        client_ids: [],
    });

    const { clearErrors, handleSubmit, watch, formState: { errors }, control, setValue, reset, getValues } = useForm({
        defaultValues: defaultValues
    });

    const invoiceOption = [
        { label: "Weekly", value: "weekly" },
        { label: "Bi-weekly", value: "bi-weekly" },
        { label: "Monthly", value: "monthly" }
    ];

    const filteredAccountsLoadOptions = async (inputValue, loadedOptions, { page }) => {
        const result = await dispatch(fetchTypes(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));

        return {
            options: result.data.map((item) => ({
                value: item.id,
                label: item.name,
            })),
            hasMore: page !== result?.last_page,
            additional: { page: page + 1 },
        };
    };

    React.useEffect(() => {
        dispatch(fetchGeneratedInvoices(currentPage, filters));
    }, [filters, currentPage]);

    const onSubmit = (data) => {
        setFilters(data);
        setSearchTerm("");
    };

    const handleResetFields = () => {
        reset(defaultValues);
        setFilters(defaultValues);
        setClientState([]);
        setSearchTerm("");
    };

    const submitCallback = (status, message) => {
        setDeleteLoading(false);
        if (status) {
            toast.success(message, {
                className: "successToast",
            })
            setSelectedItems([]);
            setSelectAll(false)
            dispatch(fetchGeneratedInvoices())
            hideConfirmDialog()
        }
        else {
            toast.error(message,
                {
                    className: "errorToast",
                }
            );
        }
    };

    const showConfirmDialog = () => {
        setDeleteModal(true);
        return
    };
    const hideConfirmDialog = () => {
        setDeleteModal(false);
    }
    const handleRemoveItems = () => {
        // setDeleteLoading(true);
        // dispatch(removeMultipleInvoices({ ids: selectedItems }, submitCallback))

        setDeleteLoading(true);
        const idsToRemove = selectedItems.filter((id) => {
            const invoice = generatedInvoices?.find((item) => item.id.toString() === id);
            return invoice && isInvoiceSelectable(invoice);
        });
        dispatch(removeMultipleInvoices({ ids: idsToRemove }, submitCallback))

        // const ids = selectedItems.filter((id) => {
        //     const invoice = generatedInvoices?.find((item) => item.id.toString() === id);
        //     return invoice && isInvoiceSelectable(invoice);
        // });

        // setSelectedItems(ids);
        // dispatch(removeMultipleInvoices({ ids }, submitCallback));
    }
    const handleChange = (e) => {
        // handle form change
        const id = e.target.dataset.value
        setSelectedItems(
            selectedItems.includes(id) ?
                selectedItems.filter((item) => item != id) :
                [...selectedItems, id]
        )
    };
    const handleToggleSelectAll = () => {
        if (selectAll) {
            setSelectedItems([])
            setSelectAll(false)
            return
        }
        setSelectAll(true)
        // setSelectedItems(generatedInvoices?.map((item) => item.id.toString()))
        // setSelectedItems(getSelectableInvoiceIds())
        setSelectedItems(selectableInvoices.map((item) => item.id.toString()))
    }

    const hideConfirmStatusDialog = () => {
        setStatusModal(false);
    }
    const showConfirmStatusDialog = (id) => {
        setStatusModal(true);
        setItemId(id)
    }
    const handleStatusPaid = (id) => {
        setStatusModal(!statusModal);
        dispatch(changeStatus(id, submitCallback));
    }

    // const handleConsolidateInvoices = () => {
    //     if (selectedItems.length < 2) {
    //         return;
    //     }

    //     Swal.fire({
    //         title: 'Consolidate Invoices?',
    //         text: 'Do you want to consolidate the selected invoices?',
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonText: 'Yes, Consolidate',
    //         cancelButtonText: 'Cancel',
    //         customClass: {
    //             confirmButton: 'swal-btn',
    //             cancelButton: 'table_delete',
    //         },
    //     }).then((result) => {
    //         if (result.isConfirmed) {
    //             setConsolidateLoading(true);
    //             dispatch(consolidateInvoices(selectedItems, (status, message) => {
    //                 setConsolidateLoading(false);
    //                 if (status) {
    //                     toast.success(message, { className: "successToast" });
    //                     setSelectedItems([]);
    //                     setSelectAll(false);
    //                     dispatch(fetchGeneratedInvoices(currentPage, filters));
    //                 } else {
    //                     toast.error(message, { className: "errorToast" });
    //                 }
    //             }));
    //         }
    //     });
    // }

    const getConsolidatableIds = () => selectedItems.filter((id) => {
        const invoice = generatedInvoices?.find((item) => item.id.toString() === id);
        return invoice && isInvoiceSelectable(invoice);
    });

    // const handleConsolidateInvoices = () => {
    //     if (selectedItems.length < 2) {
    //         return;
    //     }
    //     setConsolidateModal(true);
    // }
    const handleConsolidateInvoices = () => {
        if (getConsolidatableIds().length < 2) {
            toast.error("Please select at least two pending invoices to consolidate.", { className: "errorToast" });
            return;
        }
        setConsolidateModal(true);
    }

    // const handleConsolidateConfirm = (invoiceType) => {
    //     setConsolidateModal(false);
    //     setConsolidateLoading(true);
    //     dispatch(consolidateInvoices(selectedItems, invoiceType, (status, message) => {
    //         setConsolidateLoading(false);
    //         if (status) {
    //             toast.success(message, { className: "successToast" });
    //             setSelectedItems([]);
    //             setSelectAll(false);
    //             dispatch(fetchGeneratedInvoices(currentPage, filters));
    //         } else {
    //             toast.error(message, { className: "errorToast" });
    //         }
    //     }));
    // }

    const handleConsolidateConfirm = (invoiceType) => {
        setConsolidateModal(false);
        setConsolidateLoading(true);
        dispatch(consolidateInvoices(getConsolidatableIds(), invoiceType, (status, message) => {
            setConsolidateLoading(false);
            if (status) {
                toast.success(message, { className: "successToast" });
                setSelectedItems([]);
                setSelectAll(false);
                dispatch(fetchGeneratedInvoices(currentPage, filters));
            } else {
                toast.error(message, { className: "errorToast" });
            }
        }));
    }

    const handleDownloadSelectedInvoices = async () => {
        // setLoading(true);
        // if (!selectedItems.length) {
        //     return;
        //     setLoading(false);
        // }

        if (!selectedItems.length) {
            return;
        }

        const result = await Swal.fire({
            title: 'Download Invoices',
            text: 'Choose the file format you want to download.',
            showDenyButton: true,
            confirmButtonText: 'Download PDF',
            denyButtonText: 'Download Excel',
            reverseButtons: true,
            customClass: {
                denyButton: 'swal-btn',
                confirmButton: 'swal-btn',
            },
        });

        if (!result.isConfirmed && !result.isDenied) {
            return;
        }

        const format = result.isDenied ? 'excel' : 'pdf';

        setLoading(true);

        const response = await Api.downloadMultipleInvoices(selectedItems, format);

        if (response?.status === 200 && response.data) {
            const blob = new Blob([response.data], { type: "application/zip" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `invoices-${Date.now()}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            toast.success("Invoices downloaded successfully.", {
                className: "successToast",
            });
            setLoading(false);
        } else {
            toast.error("Unable to download invoices. Please try again.", {
                className: "errorToast",
            });
            setLoading(false);
        }
    }

    //#region TABLE HEAD 

    const renderTableHeader = React.useCallback(() => {

        const callBack = (dir, sortBy) => {
            setSortConfig({ sortBy, sortDirection: dir })
            dispatch(fetchGeneratedInvoices(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm, ...filters }))
        }
        return (
            <tr>
                <th >
                    <div className="row_check">
                        <span>#</span>
                        {(checkPermission('Delete Invoices') || checkPermission('Download Invoices')) &&
                            <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
                        }
                    </div>
                </th>


                <th>
                
                    <TableHeaderItem
                        title="Client Name"
                        sortBy="name"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Invoice Number"
                        sortBy="invoice_number"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Total Appointments"
                        sortBy="total_appointments"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>Number of Projects</th>
                <th>
                    <TableHeaderItem
                        title="Billing Date"
                        sortBy="billing_date"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>
                    <TableHeaderItem
                        title="Total bill"
                        sortBy="total_due_bill"
                        sortDirection={sortConfig.sortDirection}
                        callBack={callBack}
                    />
                </th>
                <th>Status</th>
                {(checkPermission('Change Status') || checkPermission('Download Invoices')) &&
                    <th className="col-2 text-center">Actions</th>
                }
            </tr>
        )
    }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, filters]);

    //#endregion


    //#region TABLE BODY

    const renderTableContent = React.useCallback(() => {
        return (
            generatedInvoices?.map((item, index) => (
                <InvoicesItems userToken={userToken} data={item} index={index} selectedItems={selectedItems} handleChange={handleChange} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} showConfirmStatusDialog={showConfirmStatusDialog} isInvoiceSelectable={isInvoiceSelectable} />
            ))
        )
    }, [generatedInvoices, selectedItems]);

    //#endregion


    return (
        <>
            <div className="content" style={{}}>
                    <div className="row_main_head">
                        <h2 className={`main_heading`}>Generated Invoices</h2>
                    </div>
                    <div className="card_table">
                        <form className="invoicing_form">
                            <div className='billings  row_Invoice'>
                                {/* <div className="row-primary">
                                    <h2>Invoicing Period</h2>
                                    <Controller
                                        name="invoicing_period"
                                        control={control}
                                        render={({ field }) => (
                                            <div className='select_box' style={{ width: "100%" }}>
                                                <Select
                                                    name="invoicing_period"
                                                    options={invoiceOption}
                                                    value={invoiceOption.find(opt => opt.value === field.value) || ""}
                                                    onChange={(value) => {
                                                        field.onChange(value);
                                                    }}
                                                />
                                            </div>
                                        )}
                                    />
                                </div> */}
                                <div className="row-primary">
                                    <h2>Start Date</h2>
                                    <Controller
                                        name="start_date"
                                        control={control}
                                        render={({ field }) => (
                                            <div className="input-image">
                                                <input ref={startDateRef} id='start_date' type="date" name='start_date' placeholder='Start Date' required
                                                    {...field}
                                                    value={field.value}
                                                    onChange={(e) => field.onChange(moment(new Date(e.target.value)).format("YYYY-MM-DD"))}
                                                />
                                                <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                            </div>
                                        )} />
                                </div>
                                <div className="row-primary">
                                    <h2>End Date</h2>
                                    <Controller
                                        name="end_date"
                                        control={control}
                                        render={({ field }) => (
                                            <div className="input-image ">
                                                <input ref={endDateRef} type="date" name='end_date' placeholder='End Date' required
                                                    {...field}
                                                    value={field.value}
                                                    onChange={(e) => field.onChange(moment(new Date(e.target.value)).format("YYYY-MM-DD"))}
                                                />
                                                <img src="/images/celender.png" alt="calendar Icon" className="custom-icon" />
                                            </div>
                                        )} />
                                </div>
                                <div className="row-primary">
                                    <h2>Client</h2>
                                    <Controller
                                        name="client_ids"
                                        control={control}
                                        render={({ field }) => (
                                            <div style={{ width: "100%" }}>
                                                <AsyncPaginate
                                                    menuPlacement='auto'
                                                    isMulti
                                                    styles={{
                                                        ...selectCustomStyles,
                                                    }}
                                                    value={clientState || []}
                                                    loadOptions={filteredAccountsLoadOptions}
                                                    isClearable
                                                    escapeClearsValue
                                                    onChange={(obj) => {
                                                        setClientState(obj);
                                                        field.onChange(obj.map((opt) => opt.value));
                                                    }}
                                                    additional={{
                                                        page: 1,
                                                    }}
                                                />
                                                {
                                                    errors?.client_ids?.message &&
                                                    <div style={{ marginBottom: 10 }}>
                                                        <ErrorMessage text={errors?.client_ids?.message} />
                                                    </div>
                                                }
                                            </div>
                                        )}
                                    />
                                </div>
                            </div>
        
                            <div className="row-primary btns_area row_10 mb-0 justify-content-between">
                                <div className="row-primary">
                                <SubmitButton handleSubmit={handleSubmit(onSubmit)} btnText="Search" className={'green'} />
                                <SubmitButton buttonType="button" className={'lightBlue'} btnText="Reset" handleSubmit={handleResetFields} />
                                </div>

                                <div className="row-primary">
                                {checkPermission('Delete Invoices') && selectedItems.length > 1 && (
                                    <button type="button" className="main_button green" onClick={handleConsolidateInvoices} disabled={consolidateLoading}>
                                        {consolidateLoading ? 'Consolidating...' : 'Consolidate Invoice'}
                                    </button>
                                )}
                                {checkPermission('Download Invoices') && selectedItems.length > 0 && (
                                    <button type="button" className="main_button green" onClick={handleDownloadSelectedInvoices}>
                                        Download All Invoices
                                    </button>
                                )}
                                </div>
                            </div>
                        </form>
        <ListLayout
            // heading="Generated Invoices"
            searchPlaceholder="Search Invoices"
            time={false}
            addButtonDisabled={true}
            renderTableHeader={renderTableHeader}
            renderTableContent={renderTableContent}
            totalPages={totalPages}
            fetchList={fetchGeneratedInvoices}
            selectedItems={selectedItems}
            handleRemoveItems={handleRemoveItems}
            refAddutton={refAddutton}
            addForm={addForm}
            showConfirmDialog={showConfirmDialog}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            loader={loader || loading}
            noOfItems={total}
            paginationParams={filters}
            defaultPageLength={pageLength}
            sortConfig={sortConfig}
        >
            {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} loading={deleteLoading} />}
            {statusModal && <ConfirmationStatus onClose={hideConfirmStatusDialog} isOpen={statusModal} onConfirm={() => handleStatusPaid(itemId)} />}

            <Modal isOpen={consolidateModal} toggle={() => setConsolidateModal(false)} centered>
                <ModalBody>
                    <div style={{ flexDirection: "column" }}>
                        <div className='conform_btn_area'>
                            <button className="main_button text-nowrap" onClick={() => handleConsolidateConfirm('detailed')}>Detailed invoice</button>
                            <button className="main_button text-nowrap" onClick={() => handleConsolidateConfirm('compressed')}>Compressed invoice</button>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="table_delete" onClick={() => setConsolidateModal(false)}>Cancel</button>
                </ModalFooter>
            </Modal>
        </ListLayout>
            </div>
        </div>
        </>
    )

}


const InvoicesItems = ({
    data, index, current_page, pageLength, checkPermission, selectedItems, handleChange, showConfirmStatusDialog, isInvoiceSelectable
}) => {

    const serial = useMemo(() => {
        return index + 1 + (current_page - 1) * pageLength;
    }, [current_page, pageLength]);


    return (
        <tr>
            <td>
                <div className="row_check">
                    <span>{serial}</span>
                    {(checkPermission('Download Invoices') || (checkPermission('Delete Invoices') && isInvoiceSelectable(data))) &&
                        <label className="custom-checkbox checkbox">
                            <input type="checkbox" name="select-all" data-value={data.id} checked={selectedItems.includes(data.id.toString())} onChange={handleChange} />
                            <span className="checkmark"></span>
                        </label>
                    }
                </div>
            </td>
            <td>
                {data?.client?.user?.name}
            </td>
            <td>
                {data?.invoice_number}
            </td>
            <td>
                {data?.total_appointments}
            </td>
            <td>{data?.number_of_projects || 0}</td>
            <td>
                {data?.billing_date}
            </td>
            <td>
                {`$${data?.total_due_bill}`}
            </td>
            <td>
                {data?.status}
            </td>
            {(checkPermission('Change Status') || checkPermission('Download Invoices')) &&
                <td>
                    <div className="d-flex align-content-center gap-2">
                    <div className="d-flex align-content-center gap-2">
                    {checkPermission('Download Invoices') &&
                        <Link to={`/invoices/pdf-view/${data?.id}`} className="main_button text-nowrap">View invoice</Link>
                    }
                    {/* <Link to={`/invoices/history/${data?.id}`} className="main_button text-nowrap">Invoice History</Link>
                    {checkPermission('Download Invoices') &&
                        <Link to={`/invoices/edit-view/${data?.id}`} className="main_button text-nowrap">Edit invoice</Link>
                    } */}
                    </div>
                    {(checkPermission('Change Status') && data?.status !== 'Paid') &&
                        <button onClick={() => showConfirmStatusDialog(data?.id)} className="main_button green me-2">Paid</button>
                    }
                    </div>
                </td>
            }
        </tr>
    )
}

export default InvocieList;
